import { cn } from './cn.js';

export interface AvatarProps {
  name?: string | null;
  src?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizes = {
  xs: 'w-7 h-7 text-[11px]',
  sm: 'w-9 h-9 text-xs',
  md: 'w-11 h-11 text-sm',
  lg: 'w-14 h-14 text-base',
  xl: 'w-20 h-20 text-xl',
};

const palette = [
  'from-[#E8C988] to-[#9A7E3A]',
  'from-[#D4AF66] to-[#6B5828]',
  'from-[#F5D89C] to-[#A98A4A]',
  'from-[#C9A84C] to-[#7A5D1F]',
];

function initials(name?: string | null) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}

function hash(s: string) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const tone = palette[hash(name ?? '') % palette.length];
  if (src) {
    return (
      <img
        src={src}
        alt={name ?? ''}
        className={cn(
          'rounded-full object-cover border border-line-strong',
          sizes[size],
          className,
        )}
      />
    );
  }
  return (
    <div
      aria-label={name ?? 'Avatar'}
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold text-[#1A1714] bg-gradient-to-br border border-line-strong',
        tone,
        sizes[size],
        className,
      )}
    >
      {initials(name)}
    </div>
  );
}
